import { GetClientSettings } from "./SettingsService";
import { ISalvageClientSettings } from "../interfaces/ISalvageClientSettings";
import { IFeaturedAuctions } from "../interfaces/featured-auctions/IFeaturedAuctions";
import { useVersionedData } from "./useVersionedData";
const ClientSettings: ISalvageClientSettings = GetClientSettings();

export const useFeaturedAuctions = (onError: (httpStatusCode: number, resultBody?: string) => void) =>
  useVersionedData<IFeaturedAuctions[]>(`${ClientSettings.AuctionPrivateApiUrl}/auctions/featured/`, onError);
